import { DropdownOption } from "@/models/DropdownOption";

export const countryList = require("./countryList.json") as DropdownOption[];

export interface Country {
    label: string;
    countryCode: string;
}